import { theme } from '@/components';
import type { CSSProperties, FC, PropsWithChildren } from 'react';

type BoxProps = {
  id?: string;
  className?: string;
  bordered?: boolean;
  styleElement?: string;
} & CSSProperties;

export const Box: FC<PropsWithChildren<BoxProps>> = ({
  id,
  className,
  bordered,
  children,
  styleElement,
  ...styles
}) => {
  const { token } = theme.useToken();
  return (
    <>
      {styleElement && <style>{styleElement}</style>}
      <div
        id={id}
        className={className}
        style={{
          ...(bordered && {
            border: `1px solid ${token.colorBorder}`,
            borderRadius: 8,
          }),
          ...styles,
        }}
      >
        {children}
      </div>
    </>
  );
};
